import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import "./YuxelPartnerRail.css";

// Restored from the approved Home.before-motion.jsx.backup in YUXEL-SON-VERSIYA.zip.
// These are selected professional-experience projects; do not relabel all as new YUXEL clients.
const projects = [
  { name: "BAKI EVLƏRİ", slug: "baki-evleri", logo: "/experience/compact/baki-evleri.png" },
  { name: "ART TOWER", slug: "art-tower", logo: "/experience/compact/art-tower.png" },
  { name: "FƏXRİ TOWER", slug: "fexri-tower", logo: "/experience/compact/fexri-tower.png" },
  { name: "25 PLAZA", slug: "25-plaza", logo: "/experience/compact/25-plaza.png" },
  { name: "ZENITH PLAZA", slug: "zenith-plaza", logo: "/experience/compact/zenith-plaza.png" },
  { name: "CAHAN", slug: "cahan-holding", logo: "/experience/compact/cahan.png" },
  { name: "THE WOOD", slug: "the-wood", logo: "/experience/compact/the-wood.png" },
  { name: "PARLA RESIDENCE", slug: "parla-residence", logo: "/experience/compact/parla-residence.png" },
  { name: "İNCİ RESIDENCE", slug: "inci-residence", logo: "/experience/compact/inci-residence.png" },
];

export default function YuxelPartnerRail() {
  const { t, href, lang } = useLang();
  const loop = [...projects, ...projects];
  return <section className="yx8-proof" aria-label={t("Selected experience")} data-testid="yuxel-partner-rail">
    <div className="yx8-proof-wrap">
      <header className="yx8-proof-heading">
        <div>
          <p className="yx8-proof-eyebrow">YUXEL / {t("Selected experience")}</p>
          <h2>{lang === "az" ? "YUXEL-dən əvvəlki peşəkar təcrübədən layihələr." : "Projects contributed to prior to YUXEL."}</h2>
        </div>
      </header>
    </div>
    <div className="yx8-proof-window" role="group" aria-label={t("Selected experience")}>
      <div className="yx8-proof-track">
        {loop.map((p, i) => <Link key={`${p.slug}-${i}`} to={href("/work")} className="yx8-proof-logo" aria-hidden={i >= projects.length ? true : undefined} tabIndex={i >= projects.length ? -1 : 0} aria-label={`${p.name} — ${t("All projects")}`}>
          <img src={p.logo} alt={i < projects.length ? `${p.name} logo` : ""} loading="lazy" decoding="async" />
        </Link>)}
      </div>
    </div>
    <div className="yx8-proof-wrap"><p className="yx8-proof-disclaimer">{lang === "az" ? "Loqolar təsisçinin əvvəlki peşəkar fəaliyyətində iştirak etdiyi layihələri göstərir; YUXEL-in müştəri siyahısı kimi təqdim edilmir." : "These logos represent projects from the founder’s previous professional work; they are not presented as YUXEL’s client list."}</p></div>
  </section>;
}
